var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100.000000pt",
    height: "100.000000pt",
    viewBox: "0 0 100.000000 100.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,100.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406 944 c-70 -22 -149 -103 -170 -174 -20 -67 -20 -112 -1 -176 26 -88 105 -161 199 -185 l46 -11 0 -69 0 -69 -80 0 c-73 0 -80 -2 -80 -20 0 -18 7 -20 80 -20 l80 0 0 -80 c0 -73 2 -80 20 -80 18 0 20 7 20 80 l0 80 80 0 c73 0 80 2 80 20 0 18 -7 20 -80 20 l-80 0 0 68 0 69 58 16 c203 56 267 312 116 464 -78 78 -176 101 -288 67z m168 -36 c86 -26 166 -136 166 -228 0 -124 -116 -240 -240 -240 -124 0 -240 116 -240 240 0 63 23 114 75 165 70 71 145 90 239 63z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/female.e6bee66d.svg";
export { ForwardRef as ReactComponent };